import { CameraPingDetail } from '@EcamModel/model/CameraOverview';
import { Box, Grid, Typography } from '@mui/material';
import { GridBorderRadius, GridWithGray100 } from '@pages/dashboard/styled';
import BarStackedChart from '@pages/overview/charts/BarStackedChart';
import color from '@theme/Colors';
import React from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';

export default function ScrollXBarStackedChart({ data }: { data: CameraPingDetail[] }) {
    return (
        <GridWithGray100 container item md={12} sm={12} xs={12} borderRadius={'10px'}>
            <GridBorderRadius container item border={`1px solid ${color.grey200} !important`}>
                <Typography variant="h5">Ping status</Typography>
                <Grid
                    item
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{
                        '& .chart-scroll-bar': {
                            '&::-webkit-scrollbar': {
                                height: '5px',
                            },

                            '&::-webkit-scrollbar-track': {
                                WebkitBoxShadow: 'inset 0 0 0px rgba(0, 0, 0, 0)',
                            },

                            '&::-webkit-scrollbar-thumb': {
                                height: '5px',
                                backgroundColor: color.error,
                                borderRadius: '3px',
                            },

                            '&::-webkit-scrollbar-thumb:hover': {
                                cursor: 'pointer',
                                backgroundColor: color.error,
                            },
                            '&::-webkit-scrollbar:vertical': {
                                display: 'none',
                            },
                        },
                    }}
                >
                    <Box position={'relative'} width={'100%'} height={'100%'}>
                        <ScrollContainer
                            className="container chart-scroll-bar"
                            style={{
                                height: '100%',
                                width: '100%',
                                paddingBottom: '5px',
                                position: 'relative',
                            }}
                            hideScrollbars={false}
                        >
                            <Box
                                width={
                                    data?.length > 400
                                        ? `${data?.length * 20}px`
                                        : data?.length > 10
                                        ? `${data?.length * 80}px`
                                        : '100%'
                                }
                                height={'100%'}
                                pb={4}
                                position="relative"
                            >
                                <BarStackedChart chart={data} />
                            </Box>
                        </ScrollContainer>
                    </Box>
                </Grid>
            </GridBorderRadius>
        </GridWithGray100>
    );
}
